import React from "react";
import { Switch, Route } from "react-router-dom";
import { H } from "@dossier/salvia-ui";
import styled from "styled-components";
import DocumentationMenu from "./DocumentationMenu";
import { docSections } from "./docSections";
import { MenuItem } from "./DocumentationMenuNode";

interface DocSectionsProps {
  sections?: Array<MenuItem>;
  level?: number;
}

function DocSections(props: DocSectionsProps) {
  const { sections = [], level = 0 } = props;

  const HeaderTag: any = "h" + (level + 1);

  return (
    <>
      {sections.map((section, i) => (
        <div
          key={i}
          id={section.slug || section.name}
          style={{ marginTop: "3rem" }}
        >
          {!section.noHeader && (
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
              }}
            >
              <HeaderTag style={{ marginRight: "1rem" }}>
                {section.name}
              </HeaderTag>

              <div>{section.description}</div>
            </div>
          )}

          {section.content}

          <DocSections sections={section.children} level={level + 1} />
        </div>
      ))}
    </>
  );
}

export default function Documentation() {
  return (
    <StyledDiv>
      <DocumentationMenu />

      <DocumentSectionStyle>
        <Switch>
          <Route exact path="/">
            <DocSections sections={docSections} />
          </Route>

          {/* <Route
            path="/achievement-type-overview"
            component={AchievementTypeOverview}
          /> */}

          <Route>
            <H>
              Page not found{" "}
              <span role="img" aria-label="leaves">
                🍂
              </span>
            </H>
            <p>This page does not exist (yet).</p>
          </Route>
        </Switch>
      </DocumentSectionStyle>
    </StyledDiv>
  );
}

const DocumentSectionStyle = styled.div`
  flex-grow: 1;
  padding: 0 5rem 3rem;
  box-shadow: 0px 0px 56px 0px rgba(0, 0, 0, 0.1);
  margin-left: 20rem;
  /* overflow-y: auto; */
`;

const StyledDiv = styled.div`
  display: flex;
`;
